<template>
  <div style="position: relative;" class="bg-white ">
    <right-panel class="float-right" id="sidebar-add-question-set" width="1100px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <OrganizationQuestionSetAddLibraryForm :product="currentProduct || 'PLATFORM'" />
      </div>
    </right-panel>
    <!-- <right-panel class="float-right" id="sidebar-new-question-set" width="1100px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <OrganizationQuestionSetForm :product="currentProduct || 'PLATFORM'" />
      </div>
    </right-panel> -->

    <div>
      <nav class="tab-menu">
        <div :class="{ active: activeTab === 'account' }" @click="activeTab = 'account'">
          {{ $t("question-set.assigned-to-me-pairs") }}
        </div>
        <div v-if="hasOrganizationQuestionSetViewPermission" :class="{ active: activeTab === 'organization' }" @click="activeTab = 'organization'">
          {{ $t("question-set.organization-pairs") }}
        </div>
      </nav>
      <div class="tab-content">
        <div :class="{ active: activeTab === 'account' }">
          <content-loading v-if="isMyQuestionSetsLoading" />
          <div v-else>
            <div class="qcontainer" v-if="activeTab === 'account'">
              <div class="qcard" v-for="item in myQuestionSets" :key="item._id">
                <div class="qcard--header">
                  <div class="d-flex">
                    <div class="qtitle">{{ item.name | translate }}</div>
                    <!-- <div class="qtitle2">{{ item.products.join(", ") }}</div> -->
                  </div>
                  <div class="d-flex align-items-center qactions">
                    <i
                      class="iconoir-download"
                      style="font-size: 1.5rem; color: #99A1B7; margin-right: .5rem;"
                      v-b-tooltip.hover.top="{ variant: 'main' }"
                      @click="downloadExcel(item._id)"
                      :title="$t('question-set.download')"
                    ></i>
                    <i class="iconoir-trash" @click="deleteById(item)" style="font-size: 1.5rem; color: #99A1B7;"></i>
                  </div>
                </div>
                <div class="qs-title">{{ $t("common.description") }}</div>
                <div class="qs-description">
                  {{ item.description | translate }}
                </div>

                <div class="qs-title mt-2">{{ $t("task.assignee") }}</div>
                <div class="assignee-wrapper mt-2">
                  <organization-member-select :selected="item.assignee" @onSelect="onAssigneeChanged($event, item)" style="min-width: 250px;" />

                  <i
                    v-if="item.assignee"
                    class="bx bx-x hand"
                    @click="onAssigneeChanged(undefined, item)"
                    v-b-tooltip.hover.top="{ variant: 'main' }"
                    title="Atanan Kişiyi Kaldır"
                    style="font-size: 2rem; color: #C3CCE7; "
                  ></i>

                  <i class="iconoir-info-circle" v-b-tooltip.hover.top="{ variant: 'main' }" title="Atanan Kişi" style="font-size: 1.125rem; color: #C3CCE7; "></i>
                </div>
                <hr />
                <div class="d-flex align-items-center flex-wrap">
                  <div class="icon"><i class="iconoir-chat-bubble-question"></i></div>
                  <div class="itext">{{ $t("question-set.answered-question-count") }}:</div>
                  <div class="inumber">{{ item.answeredQuestionCount }}/{{ item.questionCount }}</div>

                  <div class="icon"><i class="iconoir-medal"></i></div>
                  <div class="itext">{{ $t("common.point") }}:</div>
                  <div class="inumber">{{ item.score }}</div>

                  <button class="button accept ml-auto" @click="answerQuestionSet(item)">{{ $t("question-set.answering") }}</button>
                </div>
              </div>
            </div>

            <empty v-if="!myQuestionSetsPagination || myQuestionSetsPagination.docs.length == 0">
              <h5 class="text-center">
                {{ $t("common.no-data") }}
              </h5>
            </empty>

            <!-- Begin: Pagination -->

            <div v-if="myQuestionSetsPagination" class="row mt-4">
              <div class="col">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="myQuestionSetsRequest.options.page"
                    :total-rows="myQuestionSetsPagination.totalDocs"
                    :per-page="myQuestionSetsPagination.limit"
                    limit="10"
                    size="sm"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- End: Pagination -->
          </div>
        </div>
        <div v-if="hasOrganizationQuestionSetViewPermission" :class="{ active: activeTab === 'organization' }">
          <content-loading v-if="isOrganizationQuestionSetsLoading" />
          <div v-else>
            <div class="qcontainer" v-if="activeTab === 'organization'">
              <div class="qcard" v-for="item in organizationQuestionSets" :key="item._id">
                <div class="qcard--header">
                  <div class="d-flex">
                    <div class="qtitle">{{ item.name | translate }}</div>
                    <div class="qtitle2">{{ item.product }}</div>
                  </div>
                  <div class="d-flex align-items-center qactions">
                    <i
                      class="iconoir-download"
                      style="font-size: 1.5rem; color: #99A1B7; margin-right: .5rem;"
                      v-b-tooltip.hover.top="{ variant: 'main' }"
                      @click="downloadExcel(item._id)"
                      :title="$t('question-set.download')"
                    ></i>
                    <i class="iconoir-trash" @click="deleteById(item)" style="font-size: 1.5rem; color: #99A1B7;"></i>
                  </div>
                </div>

                <div class="qs-title">{{ $t("common.description") }}</div>
                <div class="qs-description">
                  {{ item.description | translate }}
                </div>

                <div class="qs-title mt-2">{{ $t("task.assignee") }}</div>
                <div class="assignee-wrapper mt-2">
                  <organization-member-select :selected="item.assignee" @onSelect="onAssigneeChanged($event, item)" style="min-width: 250px;" />

                  <i
                    v-if="item.assignee"
                    class="bx bx-x hand"
                    @click="onAssigneeChanged(undefined, item)"
                    v-b-tooltip.hover.top="{ variant: 'main' }"
                    title="Atanan Kişiyi Kaldır"
                    style="font-size: 2rem; color: #C3CCE7; "
                  ></i>

                  <i class="iconoir-info-circle" v-b-tooltip.hover.top="{ variant: 'main' }" title="Atanan Kişi" style="font-size: 1.125rem; color: #C3CCE7; "></i>
                </div>

                <hr />
                <div class="d-flex align-items-center flex-wrap">
                  <div class="d-flex align-items-center">
                    <div class=" icon"><i class="iconoir-chat-bubble-question"></i></div>
                    <div class="itext">{{ $t("question-set.answered-question-count") }}:</div>
                    <div class="inumber">{{ item.answeredQuestionCount }}/{{ item.questionCount }}</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="icon"><i class="iconoir-medal"></i></div>
                    <div class="itext">{{ $t("common.point") }}:</div>
                    <div class="inumber">{{ item.score }}</div>
                  </div>

                  <button class="button accept ml-auto" @click="answerQuestionSet(item)">{{ $t("question-set.answering") }}</button>
                </div>
              </div>
            </div>

            <empty v-if="!organizationQuestionSetsPagination || organizationQuestionSetsPagination.docs.length == 0">
              <h5 class="text-center">
                {{ $t("common.no-data") }}
              </h5>
            </empty>

            <!-- Begin: Pagination -->

            <div v-if="organizationQuestionSetsPagination" class="row mt-4">
              <div class="col">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="organizationQuestionSetsRequest.options.page"
                    :total-rows="organizationQuestionSetsPagination.totalDocs"
                    :per-page="organizationQuestionSetsPagination.limit"
                    limit="10"
                    size="sm"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- End: Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalSelect from "@c/modal-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import OrganizationQuestionSetAddLibraryForm from "./component/organization-question-set-add-library-form";

import OrganizationQuestionSetDetail from "./organization-question-set-detail.vue";

export default {
  props: ["scope", "product"],

  components: { ModalSelect, OrganizationQuestionSetAddLibraryForm, OrganizationMemberSelect, OrganizationQuestionSetDetail },
  data() {
    return {
      organizationQuestionSetsRequest: {
        options: { page: 1, limit: 10, sort: { no: "asc" } },
        query: { products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      },
      myQuestionSetsRequest: {
        options: { page: 1, limit: 10, sort: { no: "asc" } },
        query: { products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      },
    };
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationQuestionSet/selectedTab"];
      },
      set(v) {
        this.$store.commit("organizationQuestionSet/selectedTab", v);
      },
    },
    hasOrganizationQuestionSetViewPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_ADMIN",
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },

    myQuestionSets() {
      return this.myQuestionSetsPagination?.docs ?? [];
    },
    myQuestionSetsPagination() {
      return this.$store.getters["organizationQuestionSet/myQuestionSetsPagination"];
    },
    organizationQuestionSets() {
      return this.organizationQuestionSetsPagination?.docs ?? [];
    },
    organizationQuestionSetsPagination() {
      return this.$store.getters["organizationQuestionSet/organizationQuestionSetsPagination"];
    },
    isOrganizationQuestionSetsLoading() {
      return this.$store.getters["organizationQuestionSet/isOrganizationQuestionSetsLoading"];
    },
    isMyQuestionSetsLoading() {
      return this.$store.getters["organizationQuestionSet/isMyQuestionSetsLoading"];
    },
  },

  watch: {
    activeTab(v) {
      this.paginate();
    },
    organizationQuestionSetsRequest: {
      deep: true,
      // immediate: true, //mount anında fazladan istek gitmesin
      handler() {
        this.debounce(() => this.paginateOrganizationQuestionSets(), "organization");
      },
    },

    myQuestionSetsRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateMyQuestionSets(), "my");
      },
    },
  },
  mounted() {
    this.handleQueryParams();
  },
  methods: {
    handleQueryParams() {
      const queryParams = this.$route.query;

      const safeActiveTabs = ["account", "organization"];

      if (!queryParams) {
        return;
      }

      if (queryParams.activeTab && safeActiveTabs.includes(queryParams.activeTab)) {
        this.activeTab = queryParams.activeTab;
      }
    },
    paginate() {
      if (this.activeTab == "account") {
        return this.paginateMyQuestionSets();
      }

      return this.paginateOrganizationQuestionSets();
    },
    async paginateOrganizationQuestionSets() {
      if (!this.hasOrganizationQuestionSetViewPermission) return;

      await this.$store.dispatch("organizationQuestionSet/fetchOrganizationQuestionSets", {
        ...this.organizationQuestionSetsRequest,
        query: { ...this.organizationQuestionSetsRequest.query, products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      });
    },

    async paginateMyQuestionSets() {
      let payload = {
        ...this.myQuestionSetsRequest,
        query: {
          ...this.myQuestionSetsRequest.query,
          organization: { value: this.currentOrganization?._id, isObject: true },
          products: { value: this.currentProduct || "PLATFORM", isObject: true },
        },
      };
      if (this.scope === "ACCOUNT") {
        delete payload.query.organization;
      }

      await this.$store.dispatch("organizationQuestionSet/fetchCurrentUserAssignedQuestionSet", payload);
    },

    async onAssigneeChanged(account, questionSet) {
      if (account?._id == questionSet.assignee?._id) {
        return;
      }
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationQuestionSet/assign", { account, questionSet });

        this.$toast.success(this.$t("common.success"));
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onQuestionSetSelected(libraryItem) {
      if (!libraryItem) {
        return;
      }

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationQuestionSet/addFromLibrary", {
          libraryItem,
        });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationQuestionSet/delete`, item._id);
        this.rightPanelClosed();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { timeout: 15000 });
      }
    },

    answerQuestionSet(item) {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/question-set/answering/${item._id}`);
    },

    rightPanelClosed() {
      this.paginate();
      this.fetchLibraryItems();

      this.$store.dispatch("workspaceQuestionSet/resetForm");
      this.$store.dispatch("organizationQuestionSet/resetForm");
    },
    fetchLibraryItems() {
      this.$store.dispatch(`workspaceQuestion/paginate`, this.libraryRequest);
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel(questionSetId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data: file } = await this.$store.dispatch(`organizationQuestionSet/download`, questionSetId);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
</style>
